import { render, staticRenderFns } from "./optionalUser.vue?vue&type=template&id=5bd20900&"
import script from "./optionalUser.vue?vue&type=script&lang=js&"
export * from "./optionalUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd20900')) {
      api.createRecord('5bd20900', component.options)
    } else {
      api.reload('5bd20900', component.options)
    }
    module.hot.accept("./optionalUser.vue?vue&type=template&id=5bd20900&", function () {
      api.rerender('5bd20900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/optionalUser.vue"
export default component.exports